import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DocumentsService } from 'app/services/documents/documents.service';
import { Document } from 'app/models/dto/document.model';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { Overlay, BlockScrollStrategy } from '@angular/cdk/overlay';
import { Borrower } from 'app/modules/borrower/models/borrower/borrower.model';

export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
  return () => overlay.scrollStrategies.block();
}

@Component({
  selector: 'app-document-picker',
  templateUrl: './document-picker.component.html',
  styleUrls: ['./document-picker.component.scss'],
  providers: [
    { provide: MAT_SELECT_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] }
  ]
})
export class DocumentPickerComponent implements OnInit, OnDestroy {

  @Input() borrower: Borrower;
  @Output() selectedFile = new EventEmitter<Document[]>();

  documents: Document[] = [];
  documentsSubscription: Subscription;

  constructor(protected documentsService: DocumentsService) { }

  ngOnInit() {
    this.documentsSubscription = this.documentsService.getBorrowerDocuments(this.borrower.id)
      .subscribe({
        next: (documents) => {
          this.documents = documents;
        },
        error: (err) => console.log('Error fetching docs: ', err)
      });
  }

  ngOnDestroy() {
    this.documentsSubscription.unsubscribe();
  }

  handleSelection(value) {
    this.selectedFile.emit(value);
  }

}
